import * as React from 'react';

export function SvgChrome(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.468 8.967a7.202 7.202 0 005.153 10.101l1.696-2.94a4.14 4.14 0 01-3.986-2.209L5.468 8.967zm-.756-2.249A9.001 9.001 0 0012 21a9 9 0 008.274-12.548 9.002 9.002 0 00-15.469-1.86.895.895 0 00-.093.126zm1.856.556l1.698 2.936A4.14 4.14 0 0112 7.86h5.891A7.191 7.191 0 0012 4.8a7.183 7.183 0 00-5.432 2.474zM18.811 9.66h-3.395A4.12 4.12 0 0116.14 12a4.12 4.12 0 01-.64 2.212l-2.86 4.96A7.2 7.2 0 0018.81 9.66zm-4.753 3.454a2.34 2.34 0 10-4.144-.053l.063.109.03.057a2.338 2.338 0 003.957.045l.059-.102.035-.056z"
        fill="currentColor"
      />
    </svg>
  );
}
